import { useState, useEffect, useRef } from "react";

import "./App.css";
import { ZoomMtg } from "@zoom/meetingsdk";
import axios from "axios";
import { ColorRing } from "react-loader-spinner";

ZoomMtg.preLoadWasm();
ZoomMtg.prepareWebSDK();

function App() {
  // var authEndpoint = "";
  // var sdkKey = "";
  // var meetingNumber = "123456789";
  // var passWord = "";
  // var role = 0;
  // var userName = "React";
  // var userEmail = "";
  // var registrantToken = "";
  // var zakToken = "";
  // var leaveUrl = "http://localhost:3000";

  useEffect(async () => {
    const liff = window.liff;
    try {
      await liff.init({ liffId: "1656224658-1LbP7pB9" });
      if (!liff.isLoggedIn()) {
        liff.login();
      } else {
        try {
          let response = await liff.getProfile();
          if (Object.keys(response).length != 0) {
            setuserData(response);
          } else {
            let response = await liff.getProfile();
            setuserData(response);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  let randomNumber = 0;
  function getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min); //The maximum is inclusive and the minimum is inclusive
  }
  randomNumber =
    "ธรรมล้านดวง " + getRandomIntInclusive(100000, 999999).toString();

  const [value, setValue] = useState(randomNumber);
  const [currentDate, setCurrentDate] = useState("");
  const handleChange = (e) => setValue(e.target.value);

  //data request
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingUrl, setIsLoadingUrl] = useState(false);
  const [data, setData] = useState({});
  const [urlData, setUrlData] = useState({});
  const [userData, setuserData] = useState({});

  const getSignature = (roomID, passcode) => {
    axios
      .post(
        "https://meetingsdk-auth-endpoint-sample-production-1e28.up.railway.app/",
        {
          meetingNumber: roomID,
          role: 0,
        }
      )
      .then((res) => {
        console.log(res.data.signature);
        startMeetingN(roomID, passcode, res.data.signature);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getMeetingRoom = async () => {
    setIsLoading(true);
    let apis = [
      "https://api.thedhamma.net/redirect/room/new",
      "https://api2.thedhamma.net/redirect/room/new",
      "https://main-api.dhammajak.live/redirect/room/new",
      "https://main-02-api.dhammajak.live/redirect/room/new",
      // "https://n9n5rf7k8k.execute-api.ap-southeast-1.amazonaws.com/last/redirect/room/new",
      // "https://madoggukgi.execute-api.ap-southeast-1.amazonaws.com/last/redirect/room/new",
    ];
    let api = apis[Math.floor(Math.random() * apis.length)];

    const result = await axios({
      method: "get",
      url: "https://api.thedhamma.net/redirect/room/new",
      // url: "https://api.thedhamma.net/redirect/room",
      // url: "https://random-room-vov26botrq-as.a.run.app/range",
    });

    if (result.status == 200) {
      getSignature(result.data.roomID, result.data.passcode);
    } else {
      alert("กดปุ่มเข้าร่วมใหม่อีกครั้ง");
    }
  };

  const startMeetingN = (roomID, passcode, signature) => {
    document.getElementById("zmmtg-root").style.display = "block";

    ZoomMtg.init({
      isSupportAV: true,
      disablePreview: true,
      leaveUrl: "https://boon123.com",
      success: (success) => {
        console.log(success);
        ZoomMtg.join({
          meetingNumber: roomID,
          userName: value,
          signature: signature,
          sdkKey: "cfuFEFNQq7N7kGwnqovo7n7N17JuWP2NxQ4a",
          passWord: passcode,
          success: (success) => {
            console.log(success);
            setIsLoading(false);
          },
          error: (error) => {
            console.log(error);
          },
        });
      },
      error: (error) => {
        console.log(error);
      },
    });
  };

  const urlTargetRoom = async () => {
    // setLoading(!loading2);
    let apis = [
      "https://api.thedhamma.net/redirect/room/new",
      "https://api2.thedhamma.net/redirect/room/new",
      "https://main-api.dhammajak.live/redirect/room/new",
      "https://main-02-api.dhammajak.live/redirect/room/new",
      // "https://n9n5rf7k8k.execute-api.ap-southeast-1.amazonaws.com/last/redirect/room/new",
      // "https://madoggukgi.execute-api.ap-southeast-1.amazonaws.com/last/redirect/room/new",
    ];
    let api = apis[Math.floor(Math.random() * apis.length)];
    const result = await axios({
      method: "get",
      url: "https://api.thedhamma.net/redirect/room/new",
      // url: "https://api.thedhamma.net/redirect/room",
      // url: "https://random-room-vov26botrq-as.a.run.app/range",
    });

    // //console.log(result);
    if (result.status == 200) {
      window.location.href = result.data.base_url;
      // setLoading(!loading2);
      // } else {
      //   const room = {
      //     roomID: "94881671898",
      //     passcode: "1111",
      //     id: "1",
      //     url: "https://zoom.us/j/94881671898?pwd=VjJ3RjVDY3VnUGpkSGVUQWQzR1RGZz09",
      //     base_url:
      //       "https://zoom.us/j/94881671898?pwd=VjJ3RjVDY3VnUGpkSGVUQWQzR1RGZz09&openExternalBrowser=1",
      //   };

      //   window.location.href = room.base_url;
    } else {
      alert("กดปุ่มเข้าร่วมใหม่อีกครั้ง");
    }
  };

  return (
    <div className="App">
      <main>
        <header style={{ display: "flex" }}>
          <img className="img-side left" style={{}} src="/images/left.png" />
          <div
            style={{
              display: "flex",
              flex: "1",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h1
              style={{ textAlign: "center", color: "#5c2605", fontSize: "4vh" }}
            >
              เพจธรรมล้านดวง
            </h1>
            <h3 style={{ color: "#5c2605", fontSize: "4vh" }}>boon123.com</h3>
          </div>

          <img className="img-side right" src="/images/right.png" />
        </header>
        <section>
          <img
            src="/images/joinlowd.jpg"
            style={{ maxWidth: "650px", height: "auto" }}
          />
        </section>
        <br />
        <section
          className="logo-img"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <h3 style={{ color: "#e4bb4f", fontSize: "2.5vh" }}>
            ร่วมสวดธรรมจักรทุกวัน 2 ทุ่ม
          </h3>
          <br />
          <h4 style={{ color: "#96938c", fontSize: "2vh" }}>กรอกชื่อ</h4>

          <div
            className="inputname"
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "0px",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <input
              id="randomName"
              style={{ textAlign: "center", margin: "auto" }}
              type="text"
              placeholder="กรอกชื่อของคุณ"
              onChange={handleChange}
              defaultValue={value}
            />

            <button
              id="oneclick"
              style={{ margin: "4vh auto" }}
              className="btn"
              onClick={getMeetingRoom}
            >
              <span>กดตรงนี้ เข้าร่วมงาน (แอนดรอยด์)</span>
              <ColorRing
                visible={isLoading}
                height="35"
                width="35"
                wrapperStyle={{}}
                wrapperClass="color-ring-wrapper"
                colors={["#e15b64", "#f47e60", "#f8b26a", "#abbd81", "#849b87"]}
              />
              {/* <ClipLoader :loading="isLoading" /> */}
            </button>

            <button
              className="joinapp"
              style={{
                fontSize: "2vh",
                color: "white",
                backgroundColor: "#2d8cff",
                borderRadius: "10px",
                width: "80%",
                height: "8vh",
                boxShadow: "2px 5px 16px 0px #a3a3a3",
                marginBottom: "5vh",
                margin: "0 auto",
                paddingTop: "5px",
                paddingBottom: "5px",
                paddingLeft: "20px",
                paddingRight: "20px",
                whiteSpace: "normal",
              }}
              onClick={urlTargetRoom}
            >
              กดตรงนี้ เข้าร่วมงาน <br />
              สำหรับผู้มีแอปพลิเคชั่น zoom แล้ว
            </button>
          </div>
        </section>

        {/* <button onClick={getSignature}>Join Meeting</button> */}
      </main>
    </div>
  );
}

export default App;
